import { RowInput } from "jspdf-autotable";

export const getCustomerTableData = (
  user: string,
  email: string,
  poolGeographicalLocation: {
    state: string;
    city: string;
  },
  existingPool: boolean
) => {
  const header = [
    {
      content: "Customer Information",
      styles: { fontStyle: "bold" as const, font: "NotoSans-Regular" },
    },
    "",
  ];

  const rows: RowInput[] = [
    [
      {
        content: `${user}`,
        styles: { fontStyle: "bold" as const, font: "NotoSans-Bold" },
      },
      {
        content: `${email}`,
        styles: { fontStyle: "bold" as const, font: "NotoSans-Bold" },
      },
    ],
    [
      {
        content: `Pool Geographical Location:`,
        styles: { fontStyle: "normal" as const, font: "NotoSans-Regular" },
      },
      {
        content: `${poolGeographicalLocation.city}, ${poolGeographicalLocation.state}`,
        styles: { fontStyle: "normal" as const, font: "NotoSans-Bold" },
      },
    ],
    [
      {
        content: `The heat pump calculator is primarily used for`,
        styles: { fontStyle: "normal" as const, font: "NotoSans-Regular" },
      },
      {
        content: `${existingPool ? "An existing pool" : "A new pool"}`,
        styles: { fontStyle: "normal" as const, font: "NotoSans-Bold" },
      },
    ],
  ];
  return { header, rows };
};
